import * as React from 'react';
import { useWizard, IAbstractWizardOptions, IWizardInstance } from './instance';
import { WizardContextProvider } from './context';
import { Assign, InferProps } from '../../utils/types';
export type {
    WizardNavigationHook, IWizardNavigationHookArgs,
    IWizardActions, IWizardDerivedState,
    IWizardInstance, IWizardStateSelectors,
    IWizardStepInfo
} from './instance';

export interface IWizardHostProps extends IAbstractWizardOptions {
    /**
     * the children of wizard component
     */
    children?: React.ReactElement | React.ReactElement[];
    wizard: IWizardInstance;
}

export type WizardProps<
    THost extends React.ComponentType<IWizardHostProps>
    > = Assign<
        IAbstractWizardOptions & {
            /**
             * wizard steps or any other valid react elements
             */
            children: React.ReactElement | React.ReactElement[];

            /**
             * the component to be used as a wrapper which would host the wizard
             */
            host?: THost;
        },
        Omit<InferProps<THost>, 'wizard' | 'children'>
    >;

/** @component */
export const Wizard = <
    THost extends
    | React.ComponentType<any>
>({ defaultActiveStep, children, host, ...rest }: WizardProps<THost>) => {

    const wizardInstance = useWizard({ defaultActiveStep });

    const containerProps: any = React.useMemo(() => ({ defaultActiveStep, wizard: wizardInstance, ...rest }), [defaultActiveStep, wizardInstance, rest]);

    const wizardChildren = (host) ? (React.createElement(host, containerProps, children)) : children;

    return (
        <WizardContextProvider value={wizardInstance}>
            {wizardChildren}
        </WizardContextProvider>
    );

};

